<template>
    <v-container fluid>
        <v-row :no-gutters="noGutters">
            <sarala-table
                :elevation="false"
                :model="model"
                ref="table"
                :query="query"
                :only="onlyColumns"
                @commissionIt="commissionIt($event)"
                @decommissionIt="decommissionIt($event)"
                @toNextCommission="toNextCommission($event)"
                @toPreviousCommission="toPreviousCommission($event)"
            >
                <template #top-left v-if="showHeader">
                    <p class="subtitle-2">
                        <v-icon left>mdi-calendar-clock</v-icon
                        >{{ $tc('resources.period.name', 2) }}
                    </p>
                </template>

                <template #top-right>
                    <v-btn icon large :loading="downloading" @click="download">
                        <v-icon>
                            mdi-download
                        </v-icon>
                    </v-btn>
                </template>

                <template #situation="{ item }">
                    <v-chip label :color="item.paidColor">
                        {{ item.paidStatus }}
                    </v-chip>
                </template>

                <template #plan="{ item }">
                    {{ item.plan_name }}
                </template>

                <template #period="{ item }">
                    {{ `${item.formattedStartAt} - ${item.formattedEndAt}` }}
                </template>

                <template #resellerPayment="{ item }">
                    <a
                        v-if="item.hasBill"
                        @click="
                            $router.push({
                                name: 'bill.show',
                                params: { id: item.bill.id },
                            })
                        "
                    >
                        {{ item.resellerPayment }}
                    </a>

                    <a
                        v-if="item.hasCommission"
                        @click="
                            $router.push({
                                name: 'commissions/show',
                                params: { id: item.commission.id },
                            })
                        "
                    >
                        {{ item.resellerPayment }}
                    </a>
                </template>
            </sarala-table>
        </v-row>

        <confirm
            ref="downloadConfirm"
            width="600"
            confirmColor="success"
            confirmText="Ok"
            cancelText="Fechar"
        ></confirm>
    </v-container>
</template>

<script>
import Confirm from '@/shared/components/Confirm'
import SaralaTable from '@/shared/components/SaralaTable'
import Period from '@/models/Period'

export default {
    props: {
        // 'customer_id', 'showHeader'
        customer_id: {},
        showHeader: { default: false },
        noGutters: { default: true },
        onlyColumns: undefined,
    },

    components: {
        Confirm,
        SaralaTable,
    },

    data: () => {
        return {
            periods: null,
            downloading: false,
        }
    },

    computed: {
        model() {
            return new Period()
        },
    },

    methods: {
        query(model) {
            if (this.customer_id)
                model.with('plan').where('customer_id', this.customer_id)
            return model.with('bill').with('commission')
        },

        async download() {
            this.downloading = true
            let url = `/periods/export?${this.$store.getters[
                'filters/queryString'
            ](this.model._type)}`
            await this.$http
                .get(url)
                .then(response => {
                    if (response) {
                        this.$refs.downloadConfirm.open(
                            'Solicitação de relatório',
                            response.data.message,
                        )
                    }
                })
                .finally(() => {
                    this.downloading = false
                })
        },

        async commissionIt(period) {
            let res = await period.commissionIt()

            if (!res) return

            setTimeout(() => {
                this.$refs.table.getItems()
            }, 500)

            this.$bus.$emit(
                'notify',
                'success',
                this.$t('actions.period.commissionIt.success'),
            )
        },

        async decommissionIt(period) {
            let res = await period.decommissionIt()

            if (!res) return

            setTimeout(() => {
                this.$refs.table.getItems()
            }, 500)

            this.$bus.$emit(
                'notify',
                'success',
                this.$t('actions.period.decommissionIt.success'),
            )
        },

        async toNextCommission(period) {
            let res = await period.toNextCommission()

            if (!res) return

            setTimeout(() => {
                this.$refs.table.getItems()
            }, 500)

            this.$bus.$emit(
                'notify',
                'success',
                this.$t('actions.period.toNextCommission.success'),
            )
        },

        toPreviousCommission(period) {
            let res = period.toPreviousCommission()

            if (!res) return

            setTimeout(() => {
                this.$refs.table.getItems()
            }, 500)

            this.$bus.$emit(
                'notify',
                'success',
                this.$t('actions.period.toNextCommission.success'),
            )
        },
    },
}
</script>
